import React from "react"
import parse, { Text } from "html-react-parser"
import { urlify } from "./utils/link-parser"
import InternalLink from "./internallink/InternalLink"

export interface Props {
    content?: string
    parseHTML?: boolean
}

export default function HTMLAndInternalLinkParser(props: Props): JSX.Element {
    const { content = "", parseHTML = true } = props

    // Necessary because of https://github.com/remarkablemark/html-dom-parser/issues/420
    const replacedContent = content.replace(/\n/g, "<br />")

    if (parseHTML) {
        return (
            <>
                {parse(replacedContent, {
                    replace(domNode) {
                        if (domNode instanceof Text && domNode.data) {
                            return (
                                <>
                                    {urlify(
                                        domNode.data,
                                        (url: string, index: number) => {
                                            return (
                                                <InternalLink
                                                    url={url}
                                                    key={index}
                                                />
                                            )
                                        },
                                    )}
                                </>
                            )
                        }
                        return false
                    },
                })}
            </>
        )
    }
    return (
        <>
            {urlify(content, (url: string, index: number) => {
                return <InternalLink url={url} key={index} />
            })}
        </>
    )
}
